import React from "react";
import { Row, Col } from "antd";
import { theme } from "../../styles";
import styled from "styled-components";
// import { useSelector, useDispatch } from "react-redux";
import { Grid, BreadCrumbBox, Section, Typography, Tabel } from "../../core";
import AddProgramForm from "../../components/AddProgramForm";
// import ProgramHistory from "../../components/ProgramHistory";
import SendYarnHistory from "../../components/SendYarnHistory";

const { colors } = theme;

const typoProps = {
  as: "h2",
  align: "center",
  color: colors.Fiord,
  weight: "800",
};
const myStockcolumns = [
  {
    title: "Quality ",
    dataIndex: "quality",
    width: 150,
  },
  {
    title: "In Stock (Bags/Cones) ",
    dataIndex: "instock_bags",
    width: "150px",
  },
];
const myStockdata = [
  {
    key: "1",
    SNo: "1",
    quality: "Usama",
    instock_bags: "650909",
  },
];
const StyledTabel = styled(Tabel)`
  margin: 20px 0px;
  .ant-table-container table > thead > tr:first-child th:first-child {
    border-radius: 5px 0px 0px 0px;
  }
  .ant-table-container table > thead > tr:first-child th:last-child {
    border-radius: 0px 5px 0px 0px;
  }
`;
const Container = styled.div`
  padding: 30px 0px;
`;
const AddProgram = () => {
  const sizerId = React.useState();

  return (
    <React.Fragment>
      <Container>
        <Grid>
          <BreadCrumbBox tittle="Sizer Program" />
          <Row type="flex" justify="space-between">
            <Col lg={14} xs={24}>
              <Section className="mt-20" padding="20px;">
                <Typography {...typoProps} text="Add Program !" />
                <AddProgramForm sizerId={sizerId} />
              </Section>
            </Col>
            <Col lg={9} xs={24}>
              <Section padding="20px" className="mt-20">
                <Typography {...typoProps} text="My Stock" />
                <div>
                  {/* <StyledTabel
                    padding="0px"
                    nowidth={false}
                    pagination={false}
                    columns={myStockcolumns}
                    data={myStockdata}
                  /> */}
                  {/* <ProgramHistory sizerId={sizerId[0]} /> */}
                  <SendYarnHistory sizerId={sizerId[0]} />
                </div>
              </Section>
              <Section padding="20px" className="mt-20">
                <Typography {...typoProps} text="Total Yarn Selected" />
                <div>
                  <StyledTabel
                    padding="0px"
                    nowidth={false}
                    pagination={false}
                    columns={myStockcolumns}
                    data={myStockdata}
                  />
                  <Typography as="h5" weight="800" color={colors.Fiord}>
                    Sub Total :{" "}
                    <span style={{ fontWeight: "500" }}>220/20 </span>
                  </Typography>
                </div>
              </Section>
            </Col>
          </Row>
        </Grid>
      </Container>
    </React.Fragment>
  );
};
export default AddProgram;
